import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { roleBasedGuard } from './guards/role-based.guard';
import { RedirectionByPlatform } from './resolvers/redirection-by-platform';
import { LanguageResolver } from './resolvers/language.resolver';

const routes: Routes = [
  // Root path handling
  {
    path: '',
    resolve: {
      redirection: RedirectionByPlatform,
    },
    pathMatch: 'full',
    children: [],
  },

  // Language-specific routes
  {
    path: ':lang/admin-login/:tenantCode',
    resolve: { language: LanguageResolver },
    loadChildren: () =>
      import('./admin-login/admin-login.module').then(
        (m) => m.AdminLoginPageModule
      ),
  },
  {
    path: ':lang/login',
    resolve: { language: LanguageResolver },
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: ':lang/admin',
    resolve: { language: LanguageResolver },
    canActivate: [roleBasedGuard],
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminPageModule),
  },
  {
    path: ':lang/no-tenant-fallback',
    resolve: { language: LanguageResolver },
    loadChildren: () => import('./no-tenant-fallback/no-tenant-fallback.module').then( m => m.NoTenantFallbackPageModule)
  },

  // Legacy routes without language parameter (redirect to default language)
  {
    path: 'admin-login/:tenantCode',
    redirectTo: 'pl/admin-login/:tenantCode',
    pathMatch: 'full'
  },
  {
    path: 'login',
    redirectTo: 'pl/login',
    pathMatch: 'full'
  },
  {
    path: 'admin',
    redirectTo: 'pl/admin',
    pathMatch: 'full'
  },
  {
    path: 'no-tenant-fallback',
    redirectTo: 'pl/no-tenant-fallback',
    pathMatch: 'full'
  },

  // Catch-all redirect to default language admin
  {
    path: '**',
    redirectTo: 'pl/admin'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      enableTracing: false
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
